<template>
    <div class="wl-cooperate-enterprise-wrapper">
        <!-- <div class="cooperate-enterprise-head">
           <div class="enterprise-head-con">
               <i class="wl-icon-zhuye1"></i>
               <span class="sp-now-position">当前位置:</span>
               <span>首页</span>
               <span class="sp-head-line">></span>
               <span>合作企业</span>    
           </div>
        </div> -->
        <div class="cooperate-enterprise-main">
            <ul class="clearfix school-list-ul">
                <li v-for="(item,index) in list" :key="index" class="school-list-li fl" @click="goUrl(item.link)">
                   <p v-if="item.cover == ''">{{item.companyTitle}}</p>
                   <img :src="item.cover" alt="" class="logo-img-class">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      schoolList: [
        {
          id: "",
          SchoolName: "大连医科大学"
        },
        {
          id: "",
          SchoolName: "大连医科大学"
        },
        {
          id: "",
          SchoolName: "大连医科大学"
        }
      ],
      list:[]
    };
  },
  created() {
    this.userId =
      location.href.indexOf("www") > 0
        ? "jicvajcpzqxoderyyfirzg"
        : "f2axaeopt6bkokwltfgda";
    // this.getSchoolList(1);
    this.getCompany();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    }
  },
  methods: {
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight; //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        // this.seeMoreSchoolList();
        return false;
      }
    },
    seeMoreSchoolList() {
      this.schoolcount = this.schoolcount + 3;
      this.getSchoolList();
    },
    getSchoolList(page) {
      this.$http
        .get(urlgetSchoolList, {
          params: {
            userId: this.userId,
            page: page,
            pageSize: this.pageSize,
            schoolcount: this.schoolcount
          }
        })
        .then(rst => {
          if (rst.code == 1) {
            this.schoolList = rst.schoolList;
            this.schoolcount = rst.schoolcount;
            this.isCode = rst.isCode;
          }
        });
    },
    toHomePage() {
      this.$router.push({
        name: "xHome"
      });
    },
    getCompany(){
      var that = this;
      this.$http.post("/api/XOrg/AssociationIndex/getCompany",{
        associationId: this.association.Id
      }).then(function(rst){
        that.list = rst.list;
      })
    },
    goUrl(url){
      if(url != ''){
        if(url.indexOf("http://")<0){
          url = "http://"+url;
        }
        window.open(url,"_black");
      }
    }
  }
};
</script>

<style lang="scss">
.wl-cooperate-enterprise-wrapper {
  padding-bottom: 20px;
  .cooperate-enterprise-head {
    background: #f0f0f0;
    .enterprise-head-con {
      margin: 0 auto;
      width: 1200px;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
    }
    .sp-head-line {
      margin: 0 6px;
    }
    .sp-now-position {
      margin: 0 6px;
    }
    i {
      color: #a4a4a4;
      font-size: 16px;
    }
  }
  .cooperate-enterprise-main {
    margin: 20px auto 0;
    width: 1200px;
    .school-list-li {
      margin: 15px 15px 0 0;
      width: 390px;
      height: 70px;
      border: 1px solid #d3dbe5;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #333333;
      font-size: 16px;
      text-align: center;
      line-height: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
    }
    .logo-img-class{
      vertical-align: middle;
      max-width: 98%;
      max-height: 98%;
    }
    .school-list-li:nth-child(3n) {
      margin-right: 0;
    }
    .school-list-li:hover {
      // background: #2d82ff;
      // color: #fff;
      box-shadow:8px 6px 20px 0px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
